import { useId, useState } from 'react';
import { Button } from '@repo/design-system-kit/components/button/button';
import { FieldLabel } from '@repo/design-system-kit/components/form-elements/label/label';
import { PinCode } from '@repo/design-system-kit/components/pin-code/pin-code';
import { FormattedMessage, useIntl } from 'react-intl';
import cx from 'clsx';
import styles from './verification-code.module.css';

interface VerificationCodeProps {
  errorMessage?: string;
  isDisabled?: boolean;
  isInvalid?: boolean;
  onComplete?: (value: string) => void;
  onSendSMS: () => void;
  isLoadingSMS?: boolean;
  onOtpChange?: (otp: string) => void;
}

export function VerificationCode({
  errorMessage,
  isDisabled,
  isInvalid,
  onComplete,
  onSendSMS,
  isLoadingSMS,
  onOtpChange,
}: VerificationCodeProps): React.ReactNode {
  const { formatMessage } = useIntl();
  const labelId = useId();
  const [value, setValue] = useState('');
  return (
    <div className={styles.wrapper} data-test-react-bridge-component>
      <FieldLabel id={labelId}>{formatMessage({ id: 'labels.verification-code' })}</FieldLabel>
      <PinCode
        aria-labelledby={labelId}
        // oxlint-disable-next-line jsx-a11y/no-autofocus -- Autofocus is necessary for OTP input field, the field appear in popup and we want to drive user attention over it.
        autoFocus
        data-testid="otp-input"
        errorMessage={errorMessage}
        isDisabled={isDisabled}
        isInvalid={isInvalid}
        length={6}
        onChange={newValue => {
          setValue(newValue);
          onOtpChange?.(newValue);
        }}
        onComplete={onComplete}
        value={value}
      />
      <div className={styles.label}>
        <span className={cx('body-standard', styles.smsLabel)}>
          <FormattedMessage id="otp.verification-noreceive" />
        </span>
        <Button isLoading={isLoadingSMS} onPress={onSendSMS} type="button" variant="tertiary">
          <FormattedMessage id="otp.resend" />
        </Button>
      </div>
    </div>
  );
}
